import React, {
    memo,
    useState

} from 'react';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import '../../../../../styles/SmartRent.css';
import FormInput from '../../../../common/form/Input';
import {
    GeoKeyPropertyPropertyConfiguration,
} from '../../../../../api/PropertyIntegration';
import Button from 'reactstrap/lib/Button';
import { Col, Container, Modal, ModalHeader, Row } from 'reactstrap';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import ModalBody from 'reactstrap/lib/ModalBody';
import { getIntegrationIdsByTypeAndPropertyId } from '../../../../../api/PropertyUnits';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: GeoKeyPropertyPropertyConfiguration;
    id: number;
    reload: () => Promise<void>;
    update: (newConfig?: GeoKeyPropertyPropertyConfiguration) => void;
    setIsLoading: (isLoading: boolean) => void;
}

interface GeoKeyUnitDetails {
    unit_name: string;
    unit_id: string;
}

const GeoKeyConfiguration = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();

    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setIsLoading] = useState(false);
    const [unitlist, setUnitList] = useState([] as GeoKeyUnitDetails[]);
    // const [error, setError] = useState<string | undefined>(undefined);


    const handleUnitViewList = async () => {

        setModalOpen(true);
        setIsLoading(true);

        getIntegrationIdsByTypeAndPropertyId('5',props.id).then((result: any) => {
            if (result.success && result.data !== undefined) {
                // setIntegrationDrop(result.data);
                console.log(result.data, 'data')
                if(result.data){
                    setUnitList(_ => [...result.data]);
                }
            }
            setIsLoading(false);
        }).catch((e)=>{
            setIsLoading(false);
        })

    };

    const close = () => {
        setModalOpen(false);
        // setError(undefined);
    };

    return (
        <CollapsibleCard
            cardTitle="GeoKey Access"
            cardOpen={!!props.config}
            onCardOpenChange={open => {
                if (isUser)  return;
                props.update(
                    open
                        ? { ...props.config! }
                        : undefined
                );
            }}
        >
            <div>
                <div className="smart-rent-form-wrapper">
                    <FormInput
                        labelProps={{
                            labelText: 'Property Code',
                            invalidText: 'Please enter Property ID'
                        }}
                        inputProps={{
                            id: 'geo-key-property-id',
                            name: 'geokeyPropertyId',
                            value: props.config ? props.config.geokeyPropertyId : '',
                            type: 'string',
                            disabled: isUser
                            // required: true,
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, geokeyPropertyId: value.toString() })

                        }
                    />
                </div>
                <Button
                    text="View Units"
                    onClick={handleUnitViewList}
                    addlClassName="btn-primary"
                    className='btn-primary'
                    disabled={isUser}
                 >
                    View Units
                </Button>
                <Modal size="lg" isOpen={modalOpen} toggle={close} className="geoKey-tenant-modal">
                    <LoadingOverlay show={loading} inBootstrapColumn={false} />
                    <ModalHeader toggle={close}>Units List</ModalHeader>
                    <ModalBody>
                    {!loading && (
                                <Container>
                                    <Row className="bmx-tenant-row">
                                        <Col md={2}>
                                            <span className="item" style={{ fontWeight: 'bold' }}>Unit Id </span>
                                        </Col>
                                        <Col md={3}>
                                            <span className="item" style={{ fontWeight: 'bold' }}>Unit Name</span>
                                        </Col>
                                    </Row>
                                    {unitlist && (
                                        unitlist.map((unit, index) => {
                                            return (
                                                <Row className="bmx-tenant-row" style={{ marginTop: '24px' }}>
                                                    <Col md={2}>
                                                        <span className="item"> {unit.unit_id} </span>
                                                    </Col>
                                                    <Col md={3}>
                                                        <span className="item"> {unit.unit_name} </span>
                                                    </Col>
                                                </Row>
                                            )
                                        }
                                        )
                                    )}
                                </Container>
                                )}
                    </ModalBody>
                </Modal>
            </div>
        </CollapsibleCard>
    );
};

export default memo(GeoKeyConfiguration);


// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/GeoKeyConfigurationSection.tsx